import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { UpsertMandateTariffDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/mandate-tariffs`;

export const getMandateTariffById = (id: number, source: CancelTokenSource): Promise<UpsertMandateTariffDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};
